module.exports = __webpack_public_path__ + "img/img_i-love-curitiba_mobile.a1979e6d.jpg";